<template>
  <div class="contacts">
    <!--     Фоновая картинка   -->
    <img
      v-if="screenWidth < 768"
      class="contacts-bg"
      src="/local/templates/love-you/images/front-end/contacts/background-contact-mob.png"
      alt=""
    />
    <img
      v-else
      class="contacts-bg"
      src="/local/templates/love-you/images/front-end/contacts/background-contact-tablet.png"
      alt=""
    />

    <!--     Фоновая картинка   -->
    <h2 class="def-header-2">{{ obData?.messages?.title }}</h2>
    <div class="contacts__grid">
      <ContactCard
        v-for="item in obData.items"
        :key="item.id"
        :result="item"
        :messages="obData.messages"
      />
    </div>
  </div>
</template>

<script>
import { screenWidth } from '@use/useDeviceInfo';
import ContactCard from '@components/Contacts/ContactCard.vue';

export default {
  name: 'Contacts',
  components: {
    ContactCard,
  },
  props: {
    result: {
      type: Object,
    },
  },
  data() {
    return {
      obData: this.result,
      screenWidth,
    };
  },
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.contacts {
  //background: url("/local/templates/love-you/images/front-end/contacts/background-contact-mob.png") no-repeat;
  //background-position: top;
  &-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 0;

    @include point-lg {
      height: 100vh;
    }
  }
  &__grid {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column-reverse;

    margin-bottom: 60px;
    @include point-md {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-row: repeat(2, 1fr);
      grid-gap: 16px;
      margin-bottom: 80px;
    }
    @include point-lg {
      grid-gap: 40px;
    }
  }
  h2 {
    text-align: left;
  }
}
</style>
